import type { SurveyQuestion } from '@trinity/chat/types/survey.question';
import { SeeMore } from '@trinity/chat-components/components/presentation/SeeMore.js';
import { SurveyQuestionText } from '@/components/Survey.RichText/ReadOnly';
import styles from './style/ResponsesHeader.module.css';

type Props = {
  children?: React.ReactNode;
  question: SurveyQuestion;
};

export const SurveyResponsesHeader = ({ children, question }: Props) => {

  return (
    <div className={styles.root}>
      <SeeMore
        lineHeight={24}
        maxLines={5}>
        <SurveyQuestionText value={question.value} />
      </SeeMore>
      {children}
    </div>
  );
};

export default SurveyResponsesHeader;